module.exports = __webpack_public_path__ + "media/images/koelnbusiness_dark-f0bc44c3e25ef6598f5158fbbe66fa76.png";